(() => {
  angular
    .module('app')
    .controller(
      'host.views.debugTools.fixMyTaxInclusiveTicket.index',
      FixMyTaxInclusiveTicketController
    );

  FixMyTaxInclusiveTicketController.$inject = [
    '$scope',
    'abp.services.app.debugTool',
  ];

  function FixMyTaxInclusiveTicketController($scope, debugToolSvc) {
    const vm = this;

    vm.ticketNumber = '';
    vm.result = null;
    vm.checking = false;
    vm.fixing = false;
    vm.checkError = null;
    vm.modificationRemarks = '';
    vm.showLegendExample = false;

    vm.checkAmount = checkAmount;
    vm.fixAmount = fixAmount;

    $scope.$on('$viewContentLoaded', () => {
      App.initAjax();
    });

    function checkAmount() {
      vm.checkError = null;
      vm.result = null;

      if (!vm.ticketNumber || !vm.ticketNumber.trim()) {
        vm.checkError = 'Please enter a ticket number.';
        return;
      }

      vm.checking = true;
      debugToolSvc
        .getMalaysianForeignPatientSstTaxInfo({ ticketNumber: vm.ticketNumber.trim() })
        .success((data) => {
          vm.result = data;
          vm.modificationRemarks = '';
        })
        .error((err) => {
          vm.checkError = err && err.message ? err.message : 'An error occurred.';
        })
        .finally(() => {
          vm.checking = false;
        });
    }

    function fixAmount() {
      if (vm.fixing) return;

      const ticket = vm.result.ticketNumber;
      const message = `Reset ticket ${ticket}'s tax from ${vm.result.taxCode} (${vm.result.taxPercentage}%) to ${vm.result.correctTaxCode} (${vm.result.correctTaxPercentage}%)\nand update Amount to ${vm.result.correctAmount}?`;

      abp.message.confirm(
        message,
        `Correct SST tax for ticket ${ticket}?`,
        (confirmed) => {
          if (!confirmed) return;

          vm.fixing = true;
          debugToolSvc
            .fixMalaysianForeignPatientNullTaxInclusiveTicket({
              ticketNumber: ticket,
              modificationRemarks: vm.modificationRemarks || undefined,
            })
            .success(() => {
              abp.notify.success(`SST tax corrected for ticket ${ticket}.`);
              vm.result = null;
              vm.ticketNumber = '';
              vm.modificationRemarks = '';
              vm.checkError = null;
            })
            .error((err) => {
              const msg = err && err.message ? err.message : 'An error occurred.';
              abp.notify.error(msg);
            })
            .finally(() => {
              vm.fixing = false;
            });
        }
      );
    }
  }
})();
